import Sankey from 'highcharts/modules/sankey.js'
// load extra modules
import Map from 'highcharts/modules/map.js'
import ExportingModule from 'highcharts/modules/exporting.js'
import ExportData from 'highcharts/modules/export-data.js'
import Data from 'highcharts/modules/data.js'
import Annotations from 'highcharts/modules/annotations.js'
import Accessibility from 'highcharts/modules/accessibility.js'
import HighchartsModule from 'highcharts/highstock.js'

import './Highcharts.scss'
// initialize extra modules
Map(HighchartsModule)
Sankey(HighchartsModule)
Accessibility(HighchartsModule)
ExportData(HighchartsModule)
Data(HighchartsModule)
Annotations(HighchartsModule)
ExportingModule(HighchartsModule)

window.highcharts = HighchartsModule
let _Vue = null

export default {
  install(app) {
    if (this.installed && _Vue === app) {
      return
    }
    this.installed = true
    _Vue = app

    /**
     * Convenience method for accessing highcharts module with required modules loaded;
     * @type Object
     */
    app.$highcharts = app.config.globalProperties.$highcharts = HighchartsModule
  },
}
